import Locale, {getLocale} from '~/constants/Locale';

const getUserLocale = (): ReturnType<typeof getLocale> => Locale.KO_KR;

export default getUserLocale;
